import { gate } from 'hub-http/gates';
export const Gate = {
  GO_TO_WEBINAR_COMPONENT_MIGRATION: gate('GoToWebinar:FormSubmission:ComponentMigration'),
  MS_TEAMS_CONVERSATION_INTELLIGENCE: gate('MSTeams:ConversationIntelligence'),
  GOOGLE_MEET_AUTO_RECORD_SETTINGS: gate('GoogleMeet:AutoRecord'),
  RECORD_EVERY_MEETING_REAL_TIME_MEDIA_SETTINGS: gate('RecordEveryGoogleMeeting:RealTimeMedia')
};
export const isUngatedGoToWebinarComponentMigration = gates => {
  return gates === null || gates === void 0 ? void 0 : gates.includes(Gate.GO_TO_WEBINAR_COMPONENT_MIGRATION);
};
export const isMsTeamsConversationIntelligenceUngated = gates => {
  return gates === null || gates === void 0 ? void 0 : gates.includes(Gate.MS_TEAMS_CONVERSATION_INTELLIGENCE);
};
export const isGoogleMeetAutoRecordSettingsUngated = gates => {
  return gates === null || gates === void 0 ? void 0 : gates.includes(Gate.GOOGLE_MEET_AUTO_RECORD_SETTINGS);
};
export const isRecordEveryGoogleMeetingRealTimeMediaUngated = gates => {
  return gates === null || gates === void 0 ? void 0 : gates.includes(Gate.RECORD_EVERY_MEETING_REAL_TIME_MEDIA_SETTINGS);
};